{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "wealthlane://forms/option-award",
  "title": "Option Award",
  "description": "Stock option award — create and edit unified form.",
  "type": "object",
  "properties": {
    "participantId": {
      "$ref": "module://option-award#properties/participantId",
      "required": true,
      "permissions": { "edit": "EDIT_PARTICIPANT_FIELD" },
      "disabledDisplayField": "participantName"
    },
    "id": {
      "$ref": "module://option-award#properties/id"
    },
    "participantName": {
      "type": "string",
      "widget": "hidden"
    },
    "employeeId": {
      "$ref": "module://option-award#properties/employeeId"
    },
    "firstName": {
      "$ref": "module://option-award#properties/firstName",
      "readOnly": true
    },
    "middleName": {
      "$ref": "module://option-award#properties/middleName",
      "readOnly": true
    },
    "lastName": {
      "$ref": "module://option-award#properties/lastName",
      "readOnly": true
    },
    "awardNumber": {
      "$ref": "module://option-award#properties/awardNumber",
      "required": true
    },
    "grantId": {
      "$ref": "module://option-award#properties/grantId",
      "required": true
    },
    "planId": {
      "$ref": "module://option-award#properties/planId"
    },
    "planName": {
      "$ref": "module://option-award#properties/planName",
      "readOnly": true
    },
    "planTypeId": {
      "$ref": "module://option-award#properties/planTypeId"
    },
    "planType": {
      "$ref": "module://option-award#properties/planType",
      "readOnly": true
    },
    "grantName": {
      "$ref": "module://option-award#properties/grantName",
      "widget": "hidden"
    },
    "isOffline": {
      "$ref": "module://option-award#properties/isOffline"
    },
    "_optionExpirationInYears": {
      "type": "number",
      "widget": "hidden",
      "_internal": true
    },
    "issuedUnits": {
      "$ref": "module://option-award#properties/issuedUnits",
      "required": true
    },
    "fmvAtGrant": {
      "$ref": "module://option-award#properties/fmvAtGrant",
      "required": true
    },
    "grantPrice": {
      "$ref": "module://option-award#properties/grantPrice",
      "readOnly": true,
      "required": true
    },
    "grantValue": {
      "$ref": "module://option-award#properties/grantValue",
      "required": true
    },
    "exercisePrice": {
      "$ref": "module://option-award#properties/exercisePrice",
      "required": true
    },
    "grantIssueDate": {
      "$ref": "module://option-award#properties/grantIssueDate",
      "required": true
    },
    "vestingStartDate": {
      "$ref": "module://option-award#properties/vestingStartDate",
      "required": true
    },
    "vestingTemplateId": {
      "$ref": "module://option-award#properties/vestingTemplateId"
    },
    "vestingTemplateName": {
      "$ref": "module://option-award#properties/vestingTemplateName",
      "widget": "hidden"
    },
    "poolId": {
      "$ref": "module://option-award#properties/poolId"
    },
    "isEarlyExerciseEnabled": {
      "$ref": "module://option-award#properties/isEarlyExerciseEnabled"
    },
    "isAccepted": {
      "$ref": "module://option-award#properties/isAccepted",
      "hiddenWhen": {
        "field": "#/properties/isOffline",
        "notEquals": true
      }
    },
    "acceptanceDate": {
      "$ref": "module://option-award#properties/acceptanceDate",
      "hiddenWhen": {
        "anyOf": [
          { "field": "#/properties/isOffline", "notEquals": true },
          { "field": "#/properties/isAccepted", "notEquals": true }
        ]
      }
    },
    "awardAcceptanceDocumentInput": {
      "$ref": "module://option-award#properties/awardAcceptanceDocumentInput",
      "hiddenWhen": {
        "anyOf": [
          { "field": "#/properties/isOffline", "notEquals": true },
          { "field": "#/properties/isAccepted", "notEquals": true }
        ]
      }
    },
    "acceptanceDocumentId": {
      "$ref": "module://option-award#properties/acceptanceDocumentId"
    },
    "acceptanceDocumentRemovedIds": {
      "$ref": "module://option-award#properties/acceptanceDocumentRemovedIds"
    },
    "acceptanceDocumentName": {
      "$ref": "module://option-award#properties/acceptanceDocumentName",
      "readOnly": true
    },
    "grantReason": {
      "$ref": "module://option-award#properties/grantReason",
      "required": true
    },
    "notes": {
      "$ref": "module://option-award#properties/notes"
    },
    "expirationDate": {
      "$ref": "module://option-award#properties/expirationDate"
    },
    "optionExpirationInMonth": {
      "$ref": "module://option-award#properties/optionExpirationInMonth",
      "disabledWhen": {
        "field": "#/properties/expirationDate",
        "isEmpty": true
      }
    },
    "optionExpirationInDay": {
      "$ref": "module://option-award#properties/optionExpirationInDay",
      "disabledWhen": {
        "field": "#/properties/expirationDate",
        "isEmpty": true
      }
    },
    "methodType": {
      "$ref": "module://option-award#properties/methodType"
    },
    "methodTypeId": {
      "$ref": "module://option-award#properties/methodTypeId"
    },
    "awardAdjustmentMethodId": {
      "$ref": "module://option-award#properties/awardAdjustmentMethodId"
    },
    "asOfDate": {
      "$ref": "module://option-award#properties/asOfDate",
      "disabledWhen": {
        "field": "#/properties/methodType",
        "isEmpty": true
      }
    },
    "residualDate": {
      "$ref": "module://option-award#properties/residualDate",
      "disabledWhen": {
        "field": "#/properties/methodType",
        "isEmpty": true
      }
    },
    "amortizationDate": {
      "$ref": "module://option-award#properties/amortizationDate",
      "disabledWhen": {
        "field": "#/properties/methodType",
        "isEmpty": true
      }
    },
    "cancelShareTypeId": {
      "$ref": "module://option-award#properties/cancelShareTypeId",
      "disabledWhen": {
        "anyOf": [
          { "field": "#/properties/methodType", "isEmpty": true },
          { "field": "#/properties/asOfDate", "isEmpty": true }
        ]
      }
    },
    "targetCancelled": {
      "$ref": "module://option-award#properties/targetCancelled",
      "disabledWhen": {
        "field": "#/properties/methodType",
        "isEmpty": true
      },
      "requiredWhen": {
        "allOf": [
          { "field": "#/properties/methodType", "notEmpty": true },
          { "field": "#/properties/cancelShareTypeId", "isEmpty": true }
        ]
      }
    },
    "adjustmentReason": {
      "$ref": "module://option-award#properties/adjustmentReason",
      "disabledWhen": {
        "field": "#/properties/methodType",
        "isEmpty": true
      }
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_OPTION_AWARD",
      "successMessage": "Option Award saved successfully",
      "refreshEntities": ["Option Award"]
    }
  },
  "modes": {
    "create": {
      "type": "array",
      "items": {
        "$ref": "#"
      },
      "minItems": 1,
      "maxItems": 25,
      "dataSource": {
        "submit": {
          "actionId": "SAVE_OPTION_AWARD",
          "successMessage": "Option Award(s) created successfully",
          "refreshEntities": ["Option Award"],
          "constants": {
            "importType": "add"
          }
        }
      },
      "lifecycle": {
        "submitBehavior": "reset"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_OPTION_AWARD_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        },
        "submit": {
          "actionId": "SAVE_OPTION_AWARD",
          "successMessage": "Option Award updated successfully",
          "refreshEntities": ["Option Award"],
          "constants": {
            "importType": "edit"
          },
          "invalidateActions": ["FETCH_OPTION_AWARD"]
        }
      },
      "lifecycle": {
        "dirtyGuard": true,
        "submitBehavior": "close",
        "serverErrors": "inline"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_OPTION_AWARD_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}
